import React, { useState } from "react";
import { Globals } from "../../global/Globals";
import './BasicDetails.css'
import CryptoUtils from "../../util/cryptoUtils";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

const BasicDetails = ({ setIsExpanded, isExpanded,data, data1,details,handleTextArea,handleFormDataChange,currencyName,submitTrigger,onFormDataChange}) => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const dateFunct=(inp)=> {
    // const date = new Date(inp);
    const date = new Date(inp);
    const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  
    // const formattedDate = date.toLocaleString('en-US', options).split(', ');
  
    // return `${ formattedTime}, ${formattedDate[0]} ${formattedDate[1]}`;
  }
  const briefDetails = () => {
    return (
      <div className="brief-apply1-container">
      <div className="brief-apply1-brief-container">
        <div className="brief-apply1-left-column" style={{ display: 'flex', flexDirection: 'column', flex: '1 1 50%' }}>
          <label className="apply-brief-basic-details-description" style={{ paddingBottom: '4px' }}>
            {Globals.APPLY_BRIEF.DESCRIPTION}
          </label>
          <p className="apply-brief-basic-details-details">
            {data1?.[0]?.description || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
          </p>
          <br />
          <label className="apply-brief-basic-details-description">
            {Globals.APPLY_BRIEF.SUBMITTION_REQUIREMENTS}
          </label>
          <p className="apply-brief-basic-details-details">
            {data1?.[0]?.submissionRequirements || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
          </p>
          <br />
          <label className="apply-brief-basic-details-description">
            {Globals.APPLY_BRIEF.EVALUATION_SECTION}
          </label>
          <p className="apply-brief-basic-details-details">
            {data1?.[0]?.evalAndSelection || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
          </p>
        </div>

        {/* Right Column - Structured Information */}
        <div className="brief-apply1-right-column" style={{ display: 'flex', flexDirection: 'column', flex: '1 1 50%' }}>
          <div className="brief-apply1-details-grid" style={{ display: 'flex', flexWrap: 'wrap' }}>
            
            <div className="brief-apply1-label" style={{ flex: '1 1 70%' }}>
              {Globals.APPLY_BRIEF.CHANNEL}
            </div>
            <div className="brief-apply1-value" style={{ flex: '1 1 70%' }}>
              {data1?.[0]?.channelName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
            </div>
            <div className="brief-apply1-label" style={{ flex: '1 1 70%' }}>
              {Globals.APPLY_BRIEF.COUNTRY}
            </div>
            <div className="brief-apply1-value" style={{ flex: '1 1 70%' }}>
              {data1?.[0]?.countryName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
            </div>
            <div className="brief-apply1-label" style={{ flex: '1 1 70%' }}>
              {Globals.APPLY_BRIEF.FORMAT}
            </div>
            <div className="brief-apply1-value" style={{ flex: '1 1 70%' }}>
              {data1?.[0]?.formatName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
            </div>
            <div className="brief-apply1-label" style={{ flex: '1 1 70%' }}>
              {Globals.APPLY_BRIEF.GENRE}
            </div>
            <div className="brief-apply1-value" style={{ flex: '1 1 70%' }}>
              {data1?.[0]?.genreName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
            </div>
            <div className="brief-apply1-label" style={{ flex: '1 1 70%' }}>
              {Globals.APPLY_BRIEF.SCRIPT}
            </div>
            <div className="brief-apply1-value" style={{ flex: '1 1 70%' }}>
              {data1?.[0]?.contentTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
            </div>
            <div className="brief-apply1-label" style={{ flex: '1 1 70%' }}>
              {Globals.HALF_PAGE_BRIEF_DETAILS.CLUSTER}
            </div>
            <div className="brief-apply1-value" style={{ flex: '1 1 70%' }}>
              {data1?.[0]?.clusterName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
            </div>
            <div className="brief-apply1-label" style={{ flex: '1 1 70%' }}>
              {Globals.APPLY_BRIEF.LANGUAGE}
            </div>
            <div className="brief-apply1-value" style={{ flex: '1 1 70%' }}>
              {data1?.[0]?.languageName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
            </div>
            <div className="brief-apply1-label" style={{ flex: '1 1 70%' }}>
              {Globals.APPLY_BRIEF.PRODUCTION_TYPE}
            </div>
            <div className="brief-apply1-value" style={{ flex: '1 1 70%' }}>
              {data1?.[0]?.productionTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
              {CryptoUtils.saveToLocalStorage("prodTypeName", data1?.[0]?.productionTypeName)}
            </div>
            <div className="brief-apply1-label" style={{ flex: '1 1 70%' }}>
              {Globals.APPLY_BRIEF.CLOSING_DATE}
            </div>
            <div className="brief-apply1-value" style={{ flex: '1 1 70%' }}>
              {dateFunct(data1?.[0]?.closingDate || Globals.HALF_PAGE_BRIEF_DETAILS.NA)}
            </div>
          </div>
        </div>
      </div>
    </div>
     
    );
  };
  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};
  return (
    <>
      <div className="brief-container apply-brief-basic-info">
        <div
          className="apply-brief-expandable-header"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className="apply-brief-basic-details">{Globals.HALF_PAGE_BRIEF_DETAILS.BRIEF_DETAILS_HEADER}</div>
          <img
            onClick={() => setIsExpanded(!isExpanded)}
            src={isExpanded ? Globals.IMG.ARROW_UP : Globals.IMG.ARROW_DOWN}
            alt="toggle icon"
          />
        </div>

        {isExpanded && <div>{briefDetails()}</div>}
      </div>
    </>
  );
};

export default BasicDetails;
